import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "capitole-loader",
  role: "status",
  "aria-live": "polite",
  "aria-label": "Loading"
}
const _hoisted_2 = { class: "capitole-loader__stage" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "capitole-loader__ring" }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "capitole-loader__ring capitole-loader__ring--inner" }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "capitole-loader__pulse" }, null, -1)),
      _createElementVNode("img", {
        class: "capitole-loader__logo",
        src: _ctx.logoUrl,
        alt: "Capitole Financement",
        width: "52",
        height: "52"
      }, null, 8, _hoisted_3)
    ])
  ]))
}